module.exports = __webpack_public_path__ + "media/svg-new/bone-2-4813d813.svg";